import { render, staticRenderFns } from "./PromoActiveList.vue?vue&type=template&id=c3bc9af2&"
import script from "./PromoActiveList.vue?vue&type=script&lang=js&"
export * from "./PromoActiveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports